import { render, staticRenderFns } from "./fa-edit.vue?vue&type=template&id=f16f4536&"
import script from "./fa-edit.vue?vue&type=script&lang=js&"
export * from "./fa-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports